import { Plus, Trash2, Clock } from "lucide-react";

const inputCls = "w-full bg-[#1A1A1A] border border-[#262626] px-4 py-2.5 text-white font-['Outfit'] text-sm placeholder:text-white/25 focus:outline-none focus:border-[#C5A059]/50 transition-colors";

export default function ScheduleBuilder({ items, onChange }) {
  const add = () => onChange([...items, { time: "", activity: "", _key: `s-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` }]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const update = (i, field, value) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: value };
    onChange(next);
  };

  return (
    <div className="space-y-2">
      {items.map((item, i) => (
        <div key={item._key || `legacy-${i}`} className="flex gap-2 items-start">
          <div className="w-36 flex-shrink-0">
            <input value={item.time} onChange={e => update(i, "time", e.target.value)} placeholder="t.ex. 14:00" className={inputCls} />
          </div>
          <input value={item.activity} onChange={e => update(i, "activity", e.target.value)} placeholder="t.ex. Dörrarna öppnar & välkomstdrink" className={`${inputCls} flex-1`} />
          <button type="button" onClick={() => remove(i)} className="px-2 pt-2.5 text-white/20 hover:text-red-400 transition-colors">
            <Trash2 size={14} />
          </button>
        </div>
      ))}
      <button type="button" onClick={add} className="text-[#C5A059]/60 hover:text-[#C5A059] text-xs font-['Outfit'] flex items-center gap-1 mt-1 transition-colors">
        <Plus size={12} /> Lägg till tidpunkt
      </button>
    </div>
  );
}
